import Encoding from "encoding-japanese";


export class FileUtil {
    // content-dispositionヘッダーからファイル名を取得
    public static async getFileName(contentDisposition: string) {
        if (!contentDisposition) {
            return 'default'
        }

        let fileName = contentDisposition.substring(contentDisposition.indexOf('filename="'))
        fileName = fileName.substring(fileName.indexOf('"'))
        fileName = fileName.replaceAll('"', '')
        return fileName
    }

    // Excel用のSJISエンコードのBlobを生成
    public static async createSjisBlob(data: string, contentType: string) {
        // convert encoding. (utf-8 → shift-jis)
        const unicodeList = Encoding.stringToCode(data)
        const shiftJisCodeList = Encoding.convert(unicodeList, { to: 'SJIS', from: 'UNICODE' })
        const shiftJisString = new Uint8Array(shiftJisCodeList)

        return new Blob([shiftJisString], { type: contentType })
    }
}